module.exports = __webpack_public_path__ + "static/media/flag_en.36ab476e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag_en.svg
// module id = 742
// module chunks = 0